import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GoogleMapsService } from 'src/app/shared/services/google-maps.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { CommonBookingService } from '../common-booking.service';
declare const google: any;

@Component({
  selector: 'app-geocode',
  templateUrl: './geocode.component.html',
  styleUrls: ['./geocode.component.scss']
})
export class GeocodeComponent implements OnInit, AfterViewInit {

  @Input() booking: any;
  @Input() miscelleneousConfig;
  @Output() closeCallback = new EventEmitter();

  public selectedStop: any;
  public selectedStopIndex: number;
  public isEditMode: boolean;
  public locationControl: FormControl;
  private directionsService: any;
  private directionsRenderer: any;
  private geocoder: any;
  private routeMarkers: any[] = [];
  private selectedStopMarker: any;
  public map: any;
  private prevMarkerPosition: any;
  private mapBounds: any;
  public isSaving: boolean;
  public notification: string;
  public boundingCity: any;

  constructor(private commonBookingService: CommonBookingService, private utilService: UtilService,
              private authService: AuthService, private googleMapsService: GoogleMapsService,
              private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.locationControl = new FormControl(null);
  }

  ngAfterViewInit() {
    this.setupMap();
    this.showRouteOnMap();
  }

  setupMap() {
    const centralLocation = this.googleMapsService.convertToLatLong('12.972442, 77.580643');
    this.map = new google.maps.Map(document.getElementById('trip-route-map'), {
      zoom: 6,
      center: centralLocation,
      disableDefaultUI: true,
    });
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = this.googleMapsService.getNewDirectionsRenderer();
  }

  showRouteOnMap() {
    let bounds = new google.maps.LatLngBounds();
    const cordinates = [];
    this.routeMarkers = [];
    this.booking.stops.forEach((stop, stopIndex) => {
      if (stop.geoCord) {
        const position = this.googleMapsService.convertToLatLong(stop.geoCord);
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          icon: this.getIconSrc(stopIndex)
        });
        this.routeMarkers.push(marker);
        bounds.extend(marker.position);
        cordinates.push(position);
      }
    });

    // To avoid zoom in incase there is only one stop
    if (cordinates.length === 1) {
      bounds = this.googleMapsService.getLocationBounds(cordinates[0]);
    }
    this.mapBounds = bounds;
    this.map.fitBounds(this.mapBounds);

    // Plot route if more than one geocord is available
    if (cordinates.length > 1) {
      let waypoints = cordinates.length > 2 ? cordinates.splice(1, cordinates.length - 2) : null;
      if (waypoints) {
        waypoints = waypoints.map((point) => {
          return { location: point };
        });
      }
      if (this.googleMapsService.cacheDirectionRoutes.get(this.booking.bookingId)) {
        this.directionsRenderer.setDirections(this.googleMapsService.cacheDirectionRoutes.get(this.booking.bookingId));
        this.directionsRenderer.setMap(this.map);
        return;
      }
      this.directionsService.route({
        origin: cordinates[0],
        waypoints,
        destination: cordinates[cordinates.length - 1],
        travelMode: 'DRIVING'
      }, (response, status) => {
        if (status === 'OK') {
          this.googleMapsService.cacheDirectionRoutes.set(this.booking.bookingId, response);
          this.directionsRenderer.setDirections(response);
          this.directionsRenderer.setMap(this.map);
        } else {
          console.warn('Directions request failed due to ' + status);
        }
      });
    }
    this.geocoder = new google.maps.Geocoder();
  }

  hideRouteOnMap() {
    this.directionsRenderer.setMap(null);
    this.routeMarkers.forEach((routeMarker) => {
      routeMarker.setMap(null);
    });
  }

  showGeocodeEditorOnMap() {
    // Set bounding city
    const boundingCity = this.getCityOfStop();
    const fallbackCity = boundingCity || this.booking.city;

    this.googleMapsService.getCityCenter(fallbackCity).subscribe((cityCenter) => {

      if (boundingCity) {
        this.boundingCity = boundingCity;
        this.map.setOptions({
          restriction: {
            latLngBounds: this.googleMapsService.getLocationBounds(cityCenter, 100000),
            strictBounds: true
          }
        });
      }

      this.prevMarkerPosition = this.selectedStop.geoCord ?
        this.googleMapsService.convertToLatLong(this.selectedStop.geoCord) :
        cityCenter;

      this.selectedStopMarker = new google.maps.Marker({
        position: this.prevMarkerPosition,
        map: this.map,
        icon: 'assets/location-marker.svg',
        draggable: true
      });

      this.mapBounds = this.googleMapsService.getLocationBounds(this.prevMarkerPosition);
      this.map.fitBounds(this.mapBounds);

      google.maps.event.addListener(this.selectedStopMarker, 'dragend', () => {
        this.isSaving = true;
        if (this.miscelleneousConfig['FixGeoCoordAddressUpdate'] && this.miscelleneousConfig['FixGeoCoordAddressUpdate'] === 'true') {
          this.geocoder.geocode({ location: this.selectedStopMarker.getPosition() }, (results, status) => {
            if (results[0].formatted_address && results[0].formatted_address.indexOf('India') >= 0) {
              this.selectedStop.address = results[0].formatted_address;
              this.isSaving = false;
            }
          });
        }
        this.selectedStop.geoCord = `${this.selectedStopMarker.getPosition().lat()},${this.selectedStopMarker.getPosition().lng()}`;
      });
    });
  }

  onMarkerDragEnd(hasRestrictingCity) {
    if (hasRestrictingCity) {
      this.setSelectedStopGeoCord();
    } else {
      this.geocoder.geocode({ location: this.selectedStopMarker.getPosition() }, (results, status) => {
        if (results[0].formatted_address.indexOf('India') >= 0) {
          this.setSelectedStopGeoCord();
        } else if (this.prevMarkerPosition) {
          this.selectedStopMarker.setPosition(this.prevMarkerPosition);
        }
      });
    }
  }

  setSelectedStopGeoCord() {
    const latLng = this.selectedStopMarker.getPosition();
    this.mapBounds = this.googleMapsService.getLocationBounds(latLng);
    this.selectedStop.geoCord = `${latLng.lat()},${latLng.lng()}`;
  }

  hideGeocodeEditor() {
    this.selectedStopMarker.setMap(null);
    this.prevMarkerPosition = null;
    google.maps.event.clearListeners(this.selectedStopMarker);
  }

  editGeocode = (stopIndex: number) => {
    this.selectedStop = this.utilService.deepCopy(this.booking.stops[stopIndex]);
    this.selectedStopIndex = stopIndex;
    this.isEditMode = true;
    this.hideRouteOnMap();
    this.showGeocodeEditorOnMap();
  }

  onStopLocationChange = (location) => {
    this.stopGeoCordValidator();
    const isLocationOutsideBounds = this.locationControl.errors && this.locationControl.errors.outsideBounds;
    if (location && location.geoCord && !isLocationOutsideBounds) {
      this.selectedStop.geoCord = location.geoCord;
      if (this.miscelleneousConfig['FixGeoCoordAddressUpdate'] && this.miscelleneousConfig['FixGeoCoordAddressUpdate'] === 'true') {
        this.selectedStop.address = location.address;
      }
      const latLng = this.googleMapsService.convertToLatLong(location.geoCord);
      this.selectedStopMarker.setPosition(latLng);
      this.mapBounds = this.googleMapsService.getLocationBounds(latLng);
      this.map.fitBounds(this.mapBounds);
    }
  }

  backToGeocodeList() {
    this.selectedStop = undefined;
    this.selectedStopIndex = undefined;
    this.isEditMode = false;
    this.hideGeocodeEditor();
    this.showRouteOnMap();
  }

  getIconSrc(stopIndex) {
    if (stopIndex === 0) {
      return 'assets/pickup-marker.svg';
    } else if (stopIndex === this.booking.stops.length - 1) {
      return 'assets/drop-marker.svg';
    } else {
      return 'assets/stop-marker.svg';
    }
  }

  getStopType(stopIndex: number) {
    if (this.booking.stops[stopIndex].addressType) {
      return this.booking.stops[stopIndex].addressType;
    } else if (stopIndex === 0) {
      return 'Start';
    } else if (stopIndex === this.booking.stops.length - 1) {
      return 'End';
    } else {
      return 'Stop ' + stopIndex;
    }
  }

  cancelCallback = () => {
    this.closeCallback.emit();
  }

  getCityOfStop = () => {
    if (this.booking.bookingType !== 'Outstation') {
      return this.booking.city;
    } else {
      if (this.selectedStopIndex === 0) {
        return this.booking.city;
      } else if (this.selectedStopIndex === this.booking.stops.length - 1) {
        return this.booking.destinationCity;
      } else {
        return null;
      }
    }
  }

  saveGeocode = () => {
    const request = {
      address: this.selectedStop.address,
      bookingId: this.booking.bookingId,
      geoCord: this.selectedStop.geoCord,
      modifierBuid: this.authService.user.buId,
      modifierGuid: this.authService.user.employeeGuid,
      stopId: this.selectedStop.id
    };
    this.isSaving = true;
    this.commonBookingService.updateGeocode(request).subscribe(() => {
      this.isSaving = false;
      this.booking.stops[this.selectedStopIndex] = this.selectedStop;
      this.backToGeocodeList();
      this.changeDetectorRef.detectChanges();
    }, (error) => {
      this.isSaving = false;
      this.notification = error.error.message || 'There was an error in updating geocords';
    });
  }

  onDialogConfirm = () => {
    this.notification = '';
  }

  getLocationLabel = (option) => {
    return option.address;
  }

  stopGeoCordValidator() {
    const formControl = this.locationControl;
    if (formControl.value && (formControl.value.geoCord)) {
      this.googleMapsService.checkLocationInCity(this.boundingCity, formControl.value).subscribe((response) => {
        if (!response) {
          formControl.setErrors({
            outsideBounds: true
          });
        } else {
          formControl.setErrors(null);
        }
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  focusMap() {
    this.map.fitBounds(this.mapBounds);
  }

}
